(function () {
  if (window.__lpvpModalInitialized) return;
  window.__lpvpModalInitialized = true;

  var ICON_SELECTOR = '.lpvp-variant-info-modal-icon, .lpvp2-variant-info-modal-icon';

  function getModal() {
    return document.getElementById('lpvp-modal');
  }

  function setHtml(el, value) {
    if (!el) return;
    if (value) {
      el.innerHTML = value;
      el.style.display = '';
    } else {
      el.innerHTML = '';
      el.style.display = 'none';
    }
  }

  function setText(el, value) {
    if (!el) return;
    if (value) {
      el.textContent = value;
      el.style.display = '';
    } else {
      el.textContent = '';
      el.style.display = 'none';
    }
  }

  function openModal(trigger) {
    var modal = getModal();
    if (!modal) {
      console.warn('[LPVP Modal] #lpvp-modal not found');
      return;
    }

    var imageUrl = trigger.getAttribute('data-modal-image') || '';
    var title = trigger.getAttribute('data-modal-title') || '';
    var subtitle = trigger.getAttribute('data-modal-subtitle') || '';
    var badge = trigger.getAttribute('data-modal-badge-text') || '';
    var content = trigger.getAttribute('data-modal-content') || '';

    var imageEl = modal.querySelector('#lpvp-modal-image');
    var imageContainer = modal.querySelector('#lpvp-modal-image-container');
    var titleEl = modal.querySelector('.lpvp-modal-title');
    var subtitleEl = modal.querySelector('.lpvp-modal-subtitle');
    var badgeEl = modal.querySelector('.lpvp-modal-badge');
    var contentEl = modal.querySelector('.lpvp-modal-content');

    if (imageContainer && imageEl) {
      if (imageUrl) {
        imageEl.src = imageUrl;
        imageEl.alt = '';
        imageContainer.classList.add('has-image');
      } else {
        imageEl.removeAttribute('src');
        imageContainer.classList.remove('has-image');
      }
    }

    setHtml(titleEl, title);
    setHtml(subtitleEl, subtitle);
    setText(badgeEl, badge);
    setHtml(contentEl, content);

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    var modal = getModal();
    if (!modal || !modal.classList.contains('is-open')) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function init() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest(ICON_SELECTOR);
      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();
      openModal(trigger);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var trigger = event.target.closest(ICON_SELECTOR);
      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();
      openModal(trigger);
    });

    document.addEventListener('click', function (event) {
      if (event.target.id === 'lpvp-modal-close' || event.target.closest('#lpvp-modal-close')) {
        closeModal();
        return;
      }
      if (event.target.id === 'lpvp-modal-overlay' || event.target.closest('#lpvp-modal-overlay')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeModal();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
